// Pellicule : une vue par kami de la famille, au-dessus des boutons du pied de page. Les vues se remplissent de gauche à
// droite au fil des photos (celles du niveau en cours, voir core/gallery.js) ; les vues encore vides sont des carrés un
// peu plus foncés qui attendent leur kami. Toutes les vues tiennent sur la largeur, sans défilement (jusqu'à 15 en tout
// petit). On ne peut pas agrandir une vue ici : c'est le rôle de la galerie.
import { $, escapeHTML } from './dom.js';
import { familyName, familySprite } from '../data/family.js';

/** @param {{ t: (key: string, params?: object) => string, getLanguage: () => string }} deps */
export function createFilmStrip({ t, getLanguage }) {
  const strip = $('filmStrip');
  const list = $('filmStripList');

  /**
   * @param {import('../core/gallery.js').Portrait[]} gallery  du plus récent au plus ancien
   * @param {number} familySize  nombre de vues (un kami de la famille par vue)
   */
  function render(gallery, familySize) {
    const lang = getLanguage();
    const shots = [...gallery].reverse(); // la pellicule se lit dans l'ordre des photos
    const total = Math.max(familySize, shots.length);
    const frames = [];
    for (let i = 0; i < total; i++) {
      const p = shots[i];
      frames.push(p
        ? `<li class="film-frame is-filled" role="img" aria-label="${escapeHTML(familyName(lang, p.familyIndex))}"><img src="${escapeHTML(familySprite(p.familyIndex))}" alt="" draggable="false"></li>`
        : '<li class="film-frame" aria-hidden="true"></li>');
    }
    list.innerHTML = frames.join('');
    strip.setAttribute('aria-label', t('film.label', { count: shots.length }));
  }

  return { render };
}
